module.exports = __webpack_public_path__ + "img/comodo-ssl.ccfa0ed0.svg";